import React from "react";

/** Subtle GBR map behind light/dark modal shells (same treatment as medication checks). */
export function GbrModalBackdrop({ opacity = 0.09 }: { opacity?: number }) {
  return (
    <div
      className="pointer-events-none absolute inset-0 bg-cover bg-center bg-no-repeat rounded-[inherit]"
      style={{ backgroundImage: "url('/GBR_BG.png')", opacity }}
      aria-hidden
    />
  );
}
